export default {
  valueToLabel: (value, options) => {
    let result = ''
    options.forEach(e => {
      if (e.value === value) {
        result = e.label
      }
    })
    return result
  },
  formatDateTime: (data) => {
    return `${data.year}-${data.monthValue.toString().padStart(2, '0')}-${data.dayOfMonth.toString().padStart(2, '0')}
            ${data.hour.toString().padStart(2, '0')}:${data.minute.toString().padStart(2, '0')}:${data.second.toString().padStart(2, '0')}`
  },

  numberToCurrencyNo: (value) => {
    if (!value) return 0
    // 获取整数部分
    const intPart = Math.trunc(value)
    // 整数部分处理，增加,
    const intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
    // 预定义小数部分
    let floatPart = ''
    // 将数值截取为小数部分和整数部分
    const valueArray = value.toString().split('.')
    if (valueArray.length === 2) { // 有小数部分
      floatPart = valueArray[1].toString() // 取得小数部分
      return intPartFormat + '.' + floatPart
    }
    return intPartFormat + floatPart
  }

}



// WEBPACK FOOTER //
// ./src/utils/tool.js